import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { validateResetPasswordSearch } from '../-publicSearch';

const LazyResetPassword = lazy(() => import('./-token').then((module) => ({ default: module.ResetPassword })));

const ResetPasswordRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyResetPassword />
  </Suspense>
);

export const Route = createFileRoute('/reset-password/$token')({
  component: ResetPasswordRouteComponent,
  validateSearch: validateResetPasswordSearch,
});
